import { FileText } from 'lucide-react';
import type { Invoice } from '../../api/types.js';
import { ActivityTimeline } from './ActivityTimeline.js';

// REQ-FE-032 area B14 — rail caps the timeline to the most-recent 5
// business events with a "Voir tout l'historique →" link (today the
// link is decorative; modal disclosure is a follow-up REQ).
const RAIL_HISTORY_CAP = 5;

interface Props {
  invoice: Invoice;
}

// Right-rail companion to the centre InvoiceDetail pane in split-pane
// mode. Houses HISTORIQUE (lifted from the detail card stack) + an
// APERÇU PDF placeholder. PDF thumb generation needs S1 read-api
// integration (per mockup caption) — for now we surface the i18n string
// and an icon. Mockup ref: `docs/ux/mockup-screens/03-invoice-list.png`.
export function InvoiceDetailRail({ invoice }: Props) {
  return (
    <aside
      className="invoice-detail__rail"
      data-testid="invoice-detail-rail"
      aria-label="Historique et aperçu"
    >
      <article className="invoice-detail__card invoice-detail__rail-section">
        <div className="eyebrow">Historique</div>
        <ActivityTimeline
          primaryKey={invoice.primaryKey}
          invoiceCreatedAt={invoice.receivedAt ?? null}
          cap={RAIL_HISTORY_CAP}
        />
      </article>

      <article
        className="invoice-detail__card invoice-detail__rail-section invoice-detail__pdf-preview"
        data-testid="invoice-detail-pdf-preview"
      >
        <div className="eyebrow">Aperçu PDF</div>
        <div className="invoice-detail__pdf-thumb" aria-hidden="true">
          <FileText
            className="invoice-detail__pdf-icon"
            size={32}
            strokeWidth={1.25}
            aria-hidden="true"
          />
        </div>
        <p className="muted invoice-detail__pdf-caption">
          Aperçu Factur-X disponible après intégration S1 read-api.
        </p>
      </article>
    </aside>
  );
}
